import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import { ReactComponent as CloseIcon } from '../../../icons/close.svg';

import './modal.scss';

export const Modal = ({ title, isOpen, onClose, children, className = '' }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="modal">
      <div className="modal__overlay" onClick={onClose} />
      <div className={`modal__content ${className}`}>
        <div>
          <span>{title}</span>
          <button className="modal__close" onClick={onClose}>
            <CloseIcon width={24} height={24} />
          </button>
        </div>
        <div>{children}</div>
      </div>
    </div>,
    document.body
  );
};
